import { IGreetingsDTO } from '../../dto/greetings/greetings.dto';

export const greetingsDTO: IGreetingsDTO = {
  title: $localize`:@@page-search-content-greetings-section-title:Hi`,
  paragraph: $localize`:@@page-search-content-greetings-section-paragraph-0:Welcome to the ultimate Instagram web viewer — the service for anonymously browsing Instagram profiles for free. Our service effortlessly enables you to explore Instagram profiles without account creation or registration. Whether you're investigating a friend's profile or looking into a brand's, our tool provides a secure and discreet way to engage with Instagram.`,
};
